import * as React from 'react'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import { useField } from 'formik'
import {
  currencyString as formatCurrency,
  formatPercentage,
} from '@sales-center/common'

interface Props
  extends Omit<
    TextFieldProps,
    'name' | 'value' | 'error' | 'type' | 'onChange' | 'onBlur'
  > {
  name: string
}

export const CurrencyPercentageField: React.FC<Props> = (props) => {
  const { name, placeholder = '0.00', helperText: propsHelperText } = props

  const [field, meta, helpers] = useField<string>(name)
  const { onBlur: fieldOnBlur, ...fieldProps } = field
  const { error, touched } = meta
  const { setValue } = helpers

  const hasError = touched && error !== undefined
  const helperText = hasError && !!error ? error : propsHelperText

  const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    fieldOnBlur(event)
    if (event.target.value !== '') {
      if (!event.target.value.includes('%')) {
        const currencyValue = formatCurrency(field.value)
        setValue(currencyValue)
      } else {
        setValue(formatPercentage(event.target.value))
      }
    }
  }

  const value = field.value == '0.00' ? '' : field.value

  return (
    <TextField
      {...fieldProps}
      {...props}
      onBlur={onBlur}
      error={hasError}
      helperText={helperText}
      placeholder={placeholder}
      value={value}
    />
  )
}
CurrencyPercentageField.displayName = 'CurrencyPercentageField'
